import {Exclude, Expose, Type} from 'class-transformer';
import {UserApiModel} from '../../api/models/user.api-model';

@Exclude()
export class RankingUserApiModel {
  @Type(() => UserApiModel)
  @Expose() public user: UserApiModel;
  @Expose() public averageRating: number;
  @Expose() public ratingCount: number;
  @Expose() public rankedVehicleCount: number;
}
